import ShippingOptionsEmailForm from '@/components/CRM/ShippingOptions/ShippingOptionsEmailForm';
import { TabContentWrapper } from '@/components/_common';
import { SendOptionType } from '@/core/domain/crm/SendOptions/SendOptions.types';
import { useWindowSize } from '@/hooks';
import { PageProps } from '@/types/PageProps';
import { Form, Steps } from 'antd';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { EmailMontageFormValues } from '../ShippingOptionsManager/EmailMontagePage';
import {
  useCreateSendOption,
  useEditSendOption,
} from '@/core/domain/crm/SendOptions/SendOptions.hooks';
import mailBase64ToUrl from '@/utils/functions/mailBase64ToUrl';

interface PageParams {
  step?: string;
  type?: SendOptionType;
}

const steps = [
  {
    key: 'email',
    title: 'Montagem de e-mail',
  },
  {
    key: 'customers',
    title: 'Clientes',
  },
  {
    key: 'finalize',
    title: 'Finalizar',
  },
];

const ShippingOptionsCreatePage: React.FC<PageProps> = ({ route }) => {
  const { isMobile } = useWindowSize();
  const history = useHistory();

  const [uploading, setUploading] = useState(false);

  const [form] = Form.useForm<EmailMontageFormValues>();

  const [shippingType, setShippingType] = useState<SendOptionType>();

  const sendOptionCreate = useCreateSendOption();
  const sendOptionEdit = useEditSendOption();

  const shippingOption = null;

  useEffect(() => {
    if (shippingOption) {
      form.setFieldsValue(shippingOption);
    }
  }, [shippingOption]);

  useEffect(() => {
    const params: PageParams = Object.fromEntries(
      new URLSearchParams(history.location.search),
    );

    if (params.type) {
      setShippingType(params.type);
    }
  }, [history.location.search]);

  async function onNext() {
    try {
      if (!shippingType) return;

      const values = form.getFieldsValue();
      let newBody = '';

      newBody = await mailBase64ToUrl(values.body, setUploading);

      const result = await sendOptionCreate.mutateAsync({
        ...values,
        body: newBody,
        type: shippingType,
        systemDefaultType: false,
      });

      history.push(
        `/app/customers/crm/shippingOptions/${result.id}?type=${shippingType}&step=1`,
      );
    } catch {}
  }

  return (
    <>
      <Form form={form} layout="vertical" onFinish={onNext}>
        <TabContentWrapper title={route.name} permissions={route.permissions}>
          <div>
            <Steps
              type="navigation"
              className={
                isMobile
                  ? 'ant-steps ant-steps-vertical ant-steps-navigation'
                  : 'ant-steps ant-steps-horizontal ant-steps-label-horizontal ant-steps-navigation'
              }
              current={0}
            >
              {steps.map((step) => (
                <Steps.Step key={step.key} title={step.title} />
              ))}
            </Steps>

            <div style={{ margin: '24px 0' }}>
              <ShippingOptionsEmailForm
                shippingType={shippingType}
                loading={
                  sendOptionCreate.isLoading ||
                  sendOptionEdit.isLoading ||
                  uploading
                }
              />
            </div>
          </div>
        </TabContentWrapper>
      </Form>
    </>
  );
};

export default ShippingOptionsCreatePage;
